module.exports = __webpack_public_path__ + "img/weather35.4c58c65b.png";